import axios from 'axios';
import { X_API_KEY } from '../utils/authentication';
import i18n from '../i18n';

const apiVersion = 'v1';
// from the root of the site
let apiUrl = `${window.location.origin}/t4t/api/${apiVersion}`;

const driversAction = 'drivers';
const propertiesAction = 'properties';
const defaultsAction = 'defaults';
const opModesAction = 'opmodes';
const featuresAction = 'features';
const permissionsAction = 'permissions';
const programmingSelectionAction = 'programmingselection';
const programmingSingleSelectionAction = 'programmingsingleselection';

function getApiBaseUrl() {
    return apiUrl;
}

export function getDriversApiUrl(projectId) {
    if (projectId) {
        return `?projectId=${projectId}`;
    }
    else {
        return `/`;
    }
}

export function getDriverApiUrl(projectId, driverId) {
    return `/${driverId}?projectId=${projectId}`;
}

export function postDriverApiUrl(projectId, driverId, fwVersion, hwVersion) {
    return `?projectId=${projectId}&gtin=${driverId}&fwVersion=${fwVersion}&hwVersion=${hwVersion}`;
}

export function postDriverxmlRefApiUrl(projectId, xmlref) {
    return `/xmlref?projectId=${projectId}&xmlref=${xmlref}`;
}

export function getCountApiUrl(projectId, driverId) {
    return `/${driverId}/count?projectId=${projectId}`;
}

export function putCountApiUrl(projectId, driverId, count) {
    return `/${driverId}/count?projectId=${projectId}&driverCount=${count}`;
}

export function getPropertiesApiUrl(projectId, driverId, featureId) {
    return `/${driverId}/${propertiesAction}?projectId=${projectId}&featureId=${featureId ? featureId : '-1'}`;
}

// The driver's factory defaults, read from the DD store rather than from the project. A project
// property has only one value slot, so importing a production file overwrites each factory default
// with the value read off the device - this is the only source that survives an import.
export function getDefaultsApiUrl(projectId, driverId) {
    return `/${driverId}/${defaultsAction}?projectId=${projectId}`;
}

export function getAstroSavingsApiUrl(projectId, driverId) {
    return `/calcastrosavings?projectId=${projectId}&driverId=${driverId}`;
}

export function getOpmodesApiUrl(projectId, driverId) {
    return `/${driverId}/${opModesAction}?projectId=${projectId}`;
}

export function getOpmodesSelectedApiUrl(projectId, driverId) {
    return `/${driverId}/${opModesAction}/selected?projectId=${projectId}`;
}

export function putOpmodesSelectedApiUrl(projectId, driverId, opModeId) {
    return `/${driverId}/${opModesAction}/selected?projectId=${projectId}&opModeId=${opModeId}`;
}

export function getFeaturesApiUrl(projectId, driverId) {
    return `/${driverId}/${featuresAction}?projectId=${projectId}`;
}

export function getPermissionsApiUrl(projectId, driverId) {
    return `/${driverId}/${permissionsAction}?projectId=${projectId}`;
}

export function getLockedFeatures(projectId, driverId) {
    return `/lockedfeatures?projectId=${projectId}&driverId=${driverId}`;
}

export function getProgrammingSelectionApiUrl(projectId, driverId) {
    return `/${driverId}/${programmingSelectionAction}?projectId=${projectId}`;
}

export function putProgrammingSelectionApiUrl(projectId, driverId, featuresName) {
    return `/${driverId}/${programmingSelectionAction}?projectId=${projectId}&features=${featuresName != null ? featuresName.join(',') : ''}`;
}

export function putProgrammingSingleSelectionApiUrl(projectId, driverId, featureName, isToProgram) {
    return `/${driverId}/${programmingSingleSelectionAction}?projectId=${projectId}&feature=${featureName}&programming=${isToProgram ? 'true' : 'false'}`;
}

export function patchDriverApiUrl(projectId, driverId) {
    return `/${driverId}/properties?projectId=${projectId}`;
}

export function patchDriverNamedProps(projectId, driverId) {
    return `/${driverId}/namedproperties?projectId=${projectId}`;
}

const instance = axios.create({
    baseURL: `${getApiBaseUrl()}/${driversAction}`,
    timeout: 30000,
    headers: { 'Access-Control-Allow-Origin': '*', 'CLIENT-ID': "Frontend" }
});

instance.interceptors.request.use(config => {
    if (localStorage.getItem(X_API_KEY) !== null && typeof localStorage.getItem(X_API_KEY) === 'string' && localStorage.getItem(X_API_KEY) !== '') {
        config.headers['X-API-KEY'] = localStorage.getItem(X_API_KEY);
        config.headers['X-LANG'] = i18n.language;
    } else {
        delete config.headers['X-API-KEY'];
        config.headers['X-LANG'] = i18n.language;
    }
    return config;
});

export default instance;
